import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Пликове за завивки памучен сатен 100% памук | Размери по поръчка | GoToBed',
  description:
    'Пликове за завивки от памучен сатен 100% памук. Гладка и елегантна материя, стандартни и нестандартни размери. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Пликове за завивки памучен сатен – 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Пликове за завивки памучен сатен от 100% памук
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете пликове за завивки от памучен сатен – 100% памук, които се
          отличават с изключително гладка текстура, мекота и елегантен външен вид. Памучният сатен е
          предпочитан плат за луксозно спално бельо, защото съчетава естествената дишаемост на
          памука с по-фина и гладка повърхност. Предлагаме голямо разнообразие от размери, което
          позволява лесно да откриете точния сатенен плик за завивка за вашата завивка – независимо
          дали е стандартна или нестандартна. Налични са популярни размери като плик за завивка
          140/200, 150/220, 180/200, 200/200, 200/220 и 250/230. Колекцията включва както елегантни
          едноцветни модели, така и шарени десени с принт, които придават стил и уют на всяка
          спалня.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако искате да създадете завършен комплект спално бельо от памучен сатен, можете да
          комбинирате плика за завивка и с други продукти от същата материя:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик памучен сатен
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyPlikoveSaten />;
}

function SeoBodyPlikoveSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Пликове за завивки от памучен сатен */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Пликове за завивки от памучен сатен – мек и елегантен памучен плат
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Пликовете за завивки от памучен сатен са отличен избор за хората, които търсят меко, гладко
        и елегантно спално бельо от 100% памук.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете качествени пликове за завивки памучен сатен, които осигуряват
        комфорт по време на сън и придават стилна визия на спалнята.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Предлагаме богато разнообразие от размери, сред които популярните плик за завивка 140/200,
        150/220, 180/200, 200/200, 200/220 и 250/230, което улеснява избора на точния размер за
        вашата завивка.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако предпочитате по-плътен памучен плат, можете да разгледате и:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки от 100% памук
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Пликове за завивки от памучен сатен в много размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Пликове за завивки от памучен сатен в много размери
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите пликове за завивки от памучен сатен е богатото
          разнообразие от размери.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          При поръчка можете да изберете:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            ширина: от 120 до 300 см
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            дължина: от 190 до 230 см
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Това позволява лесно да намерите подходящ сатенен плик за завивка както за:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>единични легла</li>
          <li>стандартни двойни легла</li>
          <li>големи семейни завивки</li>
          <li>нестандартни размери</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Ако не намирате точния размер в стандартните магазини, нашите пликове за завивки по размер
          са практично и удобно решение.
        </Typography>

        {/* H2: Популярни размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери пликове за завивки от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'плик за завивка 140/200 (140x200) см',
            'плик за завивка 150/220 (150x220) см',
            'плик за завивка 180/200 (180x200) см',
            'плик за завивка 200/200 (200x200) см',
            'плик за завивка 200/220 (200x220) см',
            'плик за завивка 240/220 (240x220) см',
            'плик за завивка 250/230 (250x230) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи както за единични легла, така и за големи двойни легла и семейни
          завивки.
        </Typography>

        {/* H2: Какво представлява памучният сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е 100% памучен плат, който се изработва чрез специален начин на тъкане.
          Благодарение на тази технология материята има по-гладка повърхност и лек естествен блясък,
          което създава по-луксозно усещане.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Основни предимства на памучния сатен:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и мека на допир материя</li>
          <li>&#10004; деликатен естествен блясък</li>
          <li>&#10004; добра дишаемост</li>
          <li>&#10004; комфорт по време на сън</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Затова пликовете за завивки от памучен сатен са отличен избор за хората, които предпочитат
          по-фино и по-луксозно спално бельо.
        </Typography>

        {/* H2: Предимства на нашите пликове */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите пликове за завивки от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 4 }}>
          <li>&#10004; изработени от 100% памучен сатен</li>
          <li>&#10004; гладка и приятна на допир материя</li>
          <li>&#10004; голям избор от размери</li>
          <li>&#10004; ширина от 120 до 300 см</li>
          <li>&#10004; дължина от 190 до 230 см</li>
          <li>&#10004; подходящи за стандартни и нестандартни завивки</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>

        {/* H2: Още продукти от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Още продукти от памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете напълно завършен комплект спално бельо памучен сатен, можете да
          комбинирате плика за завивка с:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик памучен сатен
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Така лесно можете да съчетаете плик за завивка, чаршаф и калъфки в един стил и да
          създадете уютна и хармонична спалня.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за пликове за завивки памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява памучният сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучният сатен е 100% памучен плат, който се отличава с гладка структура и лек
            естествен блясък. Благодарение на специалния начин на тъкане материята е по-мека и
            по-гладка на допир, което създава по-луксозно усещане при спалното бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер плик за завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ плик за завивка, измерете ширината и дължината на вашата завивка
            или одеяло. След това изберете плик със същия или близък размер.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            В нашия магазин можете да изберете размер чрез:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>ширина: 120 – 300 см</li>
            <li>дължина: 190 – 230 см</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са пликовете за завивки от памучен сатен за големи завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на широкия диапазон от размери пликовете за завивки от памучен сатен са
            подходящи както за стандартни, така и за големи двойни и семейни завивки.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се пликът за завивка от памучен сатен след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и пликовете за завивки от памучен сатен могат да
            имат естествена свиваемост около 4–5% след първото пране. Това е нормално свойство на
            памучните материи.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Каква е разликата между памучен сатен и ранфорс?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двата плата са 100% памук, но имат различна структура.
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 1 }}>
            <li>Памучен сатен – по-гладък, по-фин плат с лек блясък и по-луксозно усещане.</li>
            <li>Ранфорс – по-плътен и по-здрав плат, подходящ за ежедневна употреба.</li>
          </Box>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Ако предпочитате по-здрав плат, разгледайте:
          </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
              sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
              пликове за завивки ранфорс
            </Typography>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват пликовете за завивки от памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички пликове за завивки от памучен сатен се изработват в България, специално за всяка
            поръчка и според избраните размери.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Колко време отнема изработката?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Срокът за изработка е 3 – 10 работни дни, като в повечето случаи поръчките са готови в
            рамките на 4 – 7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
